import Separator from "../../Separator";

import Badge from "./Badge";

const Hero = () => {
  return (
    <section className="h-screen relative text-white" id="home">
      <div className="bg-hero_overlay absolute w-full h-full z-10 bg-primary/93" />

      <video
        autoPlay
        loop
        muted
        playsInline // Prevents fullscreen on mobile
        className="absolute top-0 left-0 w-full h-full object-cover"
      >
        <source src="/assets/hero/video.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      {/* Content Container - z-30 places content above overlay and video */}
      <div className="container mx-auto h-full flex flex-col xl:flex-row items-center z-30 relative">
        {/* Main Text Content with Parallax Effect */}
        <div
          data-scroll // Locomotive Scroll attribute: enables scroll detection
          className="flex-1 flex flex-col text-center justify-center items-center xl:pb-12 gap-10 h-full"
          data-scroll-speed="0.4" // Parallax speed: moves slower than scroll (0.4x speed)
        >
          {/* Badge and Main Heading */}
          <div className="flex flex-col items-center">
            {/* Badge only shows on xl screens (hidden on mobile) */}
            <Badge containerStyles="hidden xl:flex xl:w-45 xl:h-45" />
            {/* Main Hero Heading - "Coffee" is accented */}
            <h1 className="h1 text-white">
              The Art of <span className="text-accent">Specialty</span> Coffee
            </h1>
          </div>

          {/* Decorative Separator Line */}
          <Separator />

          {/* Hero Description Text - Responsive max-width */}
          <p className="lead font-light max-w-75 md:max-w-107.5 xl:max-w-140 mb-4">
            Elevating daily rituals through artisanal roasting and curated
            origins. Welcome to the Zenbrew experience.
          </p>

          {/* Call-to-Action Button */}
          <button
            aria-label="Explore our menu"
            className="btn"
            onClick={() => {
              document
                .getElementById("menu")
                ?.scrollIntoView({ behavior: "smooth" });
            }}
          >
            Explore menu
          </button>
        </div>
      </div>
    </section>
  );
};

export default Hero;
